import React from "react";


const styles = {
  input: {
    width: "0.1px",
    height: "0.1px",
    opacity: 0,
    overflow: "hiddden",
    position: "absolute",
    zIndex: -1
  },
  label: {
    fontSize: "1.20em",
    fontWeight: 200,
    padding: 5,
    color: "white",
    backgroundColor: "black",
    display: "inline-block",
    borderRadius: 5
  }
};

export default function FilesPicker({ onFilesSelceted }) {
  return (
    <>
      <input
        type="file"
        name="file"
        id="file-input"
        multiple
        style={styles.input}
        onInput={(e) => {
          const files = e.target.files;
          if (files) {
            onFilesSelceted(files);
          }
        }}
        onClick={(e)=> { 
           e.target.value = null
        }}
      />
      <label htmlFor="file-input" style={styles.label}>
        select files
      </label>
    </>
  );
}

